const useChartZoomable = ({ seeTotalPeriod }) => {
  const timeNow = Date.now()
  const eigthHoursBack = 80
  const twentyHoursFoward = 240

  const getEightHoursBackAndTwentyHoursFowardData = ({ action }) => {
    if (seeTotalPeriod) return action

    const actionIndex = action.findIndex(item => item.timestamp > timeNow)

    if (actionIndex > eigthHoursBack)
      return action.slice(
        actionIndex - eigthHoursBack,
        actionIndex + twentyHoursFoward,
      )

    return action.slice(0, actionIndex + twentyHoursFoward)
  }

  return {
    getEightHoursBackAndTwentyHoursFowardData,
  }
}

export default useChartZoomable
